import React, { useState, useEffect } from 'react';
import './Auth.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { login, GetConfig } from '../../Authentication Services/AuthService';
import PopupModal from '../../Components/PopUp/PopUp';
import { TERMS_HTML_GB } from './Terms-en-GB';
import { DPA_HTML_GB } from './GDPR-en-GB';
import { TERMS_HTML_ES } from './Terms-es';
import { DPA_HTML_ES } from './GDPR-es';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { Navigate } from 'react-router-dom';


export const LOGIN_FAILED_ACTION = '[login action] failed login';

const Login = () => {
  const { t, i18n } = useTranslation('auth');

  const [showPassword, setShowPassword] = useState(false);
  const [isSignInButtonLoading, setIsSignInButtonLoading] = useState(false);
  const errorsObj = { email: '', password: '' };
  const [errors, setErrors] = useState(errorsObj);
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [popUpTitle, setPopUpTitle] = useState();
  const [popUpMessage, setPopUpMessage] = useState();
  const [showTos, setShowTos] = useState(false);
  const [showDpa, setShowDpa] = useState(false);

  const navigate = useNavigate();

  // --- Language switcher (persist locally until user logs in) ---
  const supported = (i18n.options?.supportedLngs || ['en', 'es']).filter(l => l !== 'cimode');
  const [lang, setLang] = useState(i18n.language);

  // useEffect(() => {
  //   const saved = localStorage.getItem('ui.lang');
  //   if (saved && saved !== i18n.language) {
  //     i18n.changeLanguage(saved);
  //     setLang(saved);
  //   }
  // }, [i18n]);

  // const onLangChange = (e) => {
  //   const newLng = e.target.value;
  //   setLang(newLng);
  //   i18n.changeLanguage(newLng);
  //   localStorage.setItem('ui.lang', newLng);
  // };
  // --------------------------------------------------------------

  const togglePassword = () => setShowPassword((prev) => !prev);

  async function onLogin(e) {
    e.preventDefault();
    let error = false;
    const errorObj = { ...errorsObj };

    if (email === '') {
      errorObj.email = t('login.email.required');
      error = true;
    }
    if (password === '') {
      errorObj.password = t('login.password.required');
      error = true;
    }
    setErrors(errorObj);
    if (error) return;

    setIsSignInButtonLoading(true);

    login(email, password)
      .then((res) => {
        console.log(res.data)
        if (res.data.reason === "choose_plan")
        {
          navigate("/choose-plan?userId="+res.data.id)
        }
        else if (res.data.reason === "billing_portal")
        {
          window.location.href = res.data.url
          // navigate(res.data.url)
        }
        else{
          localStorage.setItem('table.pageSize', String(8));
          GetConfigWrapper()
        }

      })
      .catch((error) => {
        switch (error?.response?.data) {
          case 'A user with this email already exists':
            setPopUpTitle(t('login.popup.title'));
            setPopUpMessage(t('login.errors.emailExists'));
            break;
          case 'Email not found':
            setPopUpTitle(t('login.popup.title'));
            setPopUpMessage(t('login.errors.emailNotFound'));
            break;
          case 'Password incorrect':
            setPopUpTitle(t('login.popup.title'));
            setPopUpMessage(t('login.errors.incorrectPassword'));
            break;
          default:
            setPopUpTitle(t('login.popup.title'));
            setPopUpMessage(t('login.errors.generic'));
        }

        if (!error?.response) {
          setPopUpTitle(t('login.popup.title'));
          setPopUpMessage(t('login.errors.generic'));
        }
        setShowPopup(true);
      })
      .finally(() => 
        {
          setIsSignInButtonLoading(false)
          
        });

  }

  function GetConfigWrapper() {
      GetConfig().then((res) => {
        const lang = res?.data?.systemLanguage || 'en';
        i18n.changeLanguage(lang);
        localStorage.setItem('ui.lang', lang);
      }).catch((error) => {
      }).finally(() => {
        // navigate("/overview", { state: { showLoginLoader: true } });
        navigate('/overview');
        // navigate(0);
      })
    }

  const handlePopupResult = () => setShowPopup(false);

  return (
    <div className="login-background">
      <div className="login-container">
          <div style={{display:"flex", justifyContent:"flex-end"}}>
            <label htmlFor="lang-switch" className="visually-hidden">
              {t('login.lang.ariaLabel')}
            </label>
                <div className="centered-select">
            </div>
            <select
              id="lang-switch"
              value={lang}
              onChange={(e) => {i18n.changeLanguage(e.target.value); setLang(e.target.value); localStorage.setItem('ui.lang', e.target.value);}}
              aria-label={t('login.lang.ariaLabel')}
              className="lang-select"
              style={{
                
                padding: '6px 10px',
                borderRadius: 6,
                border: '1px solid #ddd',
                background: '#fff'
              }}
            >
              {supported.map(code => (
                <option key={code} value={code}>
                  {t(`login.lang.names.${code}`, code.toUpperCase())}
                </option>
              ))}
            </select>
          </div>
        {/* Header row: title/subtitle on the left, language on the right */}
        <div className="login-header mt-4" style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
          <div style={{ flex: 1 }}>
            <h1 className="login-title" style={{ marginBottom: 4 }}>{t('login.title')}</h1>
            <p className="login-subtitle" style={{ margin: 0 }}>{t('login.subtitle')}</p>
          </div>

        </div>

        <form className="login-form" onSubmit={onLogin}>
          <label htmlFor="email">{t('login.email.label')}</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            id="email"
            placeholder={t('login.email.placeholder')}
            required
          />
          {errors.email && <div className="form-error">{errors.email}</div>}

          <label htmlFor="password">{t('login.password.label')}</label>
          <div className="password-wrapper">
            <input
              type={showPassword ? 'text' : 'password'}
              id="password"
              placeholder={t('login.password.placeholder')}
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              className="eye-button"
              onClick={togglePassword}
              aria-label={t('login.password.toggleAria')}
            >
              {showPassword ? <FaEyeSlash className="eye-icon" /> : <FaEye className="eye-icon" />}
            </button>
          </div>
          {errors.password && <div className="form-error">{errors.password}</div>}

          <button className="signin-btn" onClick={onLogin} disabled={isSignInButtonLoading}>
            {isSignInButtonLoading ? <span className="loader" /> : t('login.actions.signIn')}
          </button>

          <p className="policy-text">
            {t('login.policy.prefix')}{' '}
            <button type="button" className="policy-link" onClick={() => setShowTos(true)}>
              {t('login.policy.terms')}
            </button>{' '}
            {t('login.policy.and')}{' '}
            <button type="button" className="policy-link" onClick={() => setShowDpa(true)}>
              {t('login.policy.dpa')}
            </button>
            .
          </p>
        </form>

        <div className="login-footer">
          <a href="/request-forgot-password">{t('login.links.forgot')}</a>
          <a href="/register">{t('login.links.register')}</a>
        </div>
      </div>

      <PopupModal
        isOpen={showPopup}
        title={popUpTitle}
        message={popUpMessage}
        showOk={false}
        showCancel={true}
        onClose={handlePopupResult}
      />

      {showTos && (
        <div className="policy-modal-overlay" role="dialog" aria-modal="true" onClick={() => setShowTos(false)}>
          <div className="policy-modal" onClick={(e) => e.stopPropagation()}>
            <div className="policy-modal__header">
              <h3>{t('login.modals.terms.title')}</h3>
              <button className="policy-close" onClick={() => setShowTos(false)} aria-label={t('login.modals.closeAria')}>
                ×
              </button>
            </div>
            <div className="policy-modal__body" dangerouslySetInnerHTML={{ __html: lang === "en" ? TERMS_HTML_GB : lang === "es" ? TERMS_HTML_ES : TERMS_HTML_GB}} />
            <div className="policy-modal__actions">
              <button className="btn-neutral" onClick={() => setShowTos(false)}>
                {t('login.modals.close')}
              </button>
            </div>
          </div>
        </div>
      )}

      {showDpa && (
        <div className="policy-modal-overlay" role="dialog" aria-modal="true" onClick={() => setShowDpa(false)}>
          <div className="policy-modal" onClick={(e) => e.stopPropagation()}>
            <div className="policy-modal__header">
              <h3>{t('login.modals.dpa.title')}</h3>
              <button className="policy-close" onClick={() => setShowDpa(false)} aria-label={t('login.modals.closeAria')}>
                ×
              </button>
            </div>
            <div className="policy-modal__body" dangerouslySetInnerHTML={{ __html: lang === "en" ? DPA_HTML_GB : lang === "es" ? DPA_HTML_ES : DPA_HTML_GB }} />
            <div className="policy-modal__actions">
              <button className="btn-neutral" onClick={() => setShowDpa(false)}>
                {t('login.modals.close')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  errorMessage: state.auth.errorMessage,
  successMessage: state.auth.successMessage,
  showLoading: state.auth.showLoading,
});

export default connect(mapStateToProps)(Login);
